// All assets served locally from /public/assets/ to avoid hotlink/CORS issues.
export const ASSETS = {
  // Fifi mascot
  fifiHero: "/assets/fifi/fifi-happy.png",
  fifiSad: "/assets/fifi/fifi-cry.png",
  fifiCheer: "/assets/fifi/fifi-wave.png",
  fifiQuant: "/assets/fifi/fifi-quant.png",
  fifiSleepy: "/assets/fifi/fifi-happy.png",
  fifiWave: "/assets/fifi/fifi-wave.png",

  // Brand
  wordmark: "/assets/brand/wordmark.png",
  pawIcon: "/assets/brand/paw.png",

  // Fifi system mobile screens (used in Fifi Store landing section)
  fifiCloset: "/assets/app/closet.png",
  fifiStoreScreen: "/assets/app/store-screen.png",
  fifiWorld: "/assets/app/fifi-world.png",
  fifiRewards: "/assets/app/rewards.png",

  // App screens
  fifiStore: "/assets/app/store.png",
  fifiQuantScreen: "/assets/app/quant.png",
  quantComingSoon: "/assets/app/quant.png",
  rewardScreen: "/assets/app/store.png",
  marketScreen: "/assets/app/market.png",
  assetScreen: "/assets/app/asset.png",
  orderComplete: "/assets/app/order.png",
  openScreen: "/assets/app/open.png",
  holdingUp: "/assets/app/asset.png",
  holdingDown: "/assets/app/order.png",

  // Unsplash Gen Z trader (external — fine, Unsplash allows hotlinking)
  genZ: "https://images.unsplash.com/photo-1662858557337-48c9ecf07ee0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxHZW4lMjBaJTIwbW9iaWxlJTIwcGhvbmUlMjB1c2luZyUyMHNtaWxpbmd8ZW58MHx8fHwxNzgwMDgxMTExfDA&ixlib=rb-4.1.0&q=85",
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
